import React, { useRef } from 'react';
import { Row, Col } from 'reactstrap';
import moment from 'moment/moment';
import { useReactToPrint } from 'react-to-print';

//Components
import MainCard from '../../../components/MainCard/MainCard';

//Context
import { useAuth } from '../../../context/auth';

export default function RelatorioDemonstrativoDeResumoDeOperacoes({ dadosRelatorio, btnVoltar, filtros }) {
    const { setupVariavel, session } = useAuth();
    const refRelatorio = useRef();
    
    //Função assionada assim que o botão de imprimir pdf é clicado
    const handlePrint = useReactToPrint({
        content: () => refRelatorio.current,
        copyStyles: true,
        documentTitle: "Relatório detalhado por transportador",
    });

   
    return (
        <MainCard btnVoltarInTop={btnVoltar} btnImprimir={handlePrint}>
            <div className="mt-4 relatorio w-100" ref={refRelatorio}>
                <div className="print m-2 d-flex align-items-center justify-content-between">
                    <p>Emitido por: {session.nome}</p>
                    <p>Data de emissão: {moment().format("DD/MM/YYYY HH:mm")}</p>
                </div>
                {setupVariavel?.logoTipo &&
                    <div className="d-flex align-items-center justify-content-center">
                        <img src={"data:image/png;base64," + setupVariavel?.logoTipo} style={{ maxWidth: '70%'}} />
                    </div>
                }
                <div className="header">
                    <h4 className='text-black'>Relatório demonstrativo de resumo de operações</h4>
                    <Row>
                        <div className='col-4'>
                            <p><span className="fw-bold">Período:</span> {moment(filtros.dataInicial).format("DD/MM/YYYY")} à {moment(filtros.dataFinal).format("DD/MM/YYYY")}</p>
                        </div>
                    </Row>
                    <Row>
                        <div className='col-4'>
                            {filtros.geradorId_selected
                                ?
                                <p><span className="fw-bold">Gerador:</span> {filtros.geradorId_selected.label}</p>
                                :
                                <p><span className="fw-bold">Gerador:</span> Todos</p>
                            }
                        </div>
                        <div className='col-4'>
                            {filtros.modalidadeId_selected
                                ?
                                <p><span className="fw-bold">Modalidade:</span> {filtros.modalidadeId_selected.label}</p>
                                :
                                <p><span className="fw-bold">Modalidade:</span> Todas</p>
                            }
                        </div>
                    </Row>
                </div>
                <div className="body">
                    <h5 className='rounded-3 bg-secondary text-light p-2'>DADOS DO TRANSPORTADOR</h5>
                    <Row className='content-rel mb-4'>
                        <div className="col-6"><span className="fw-bold">Nome:</span> {dadosRelatorio.transportador.fantasia}</div>
                        <div className="col-6"><span className="fw-bold">CNPJ:</span> {dadosRelatorio.transportador.cnpj}</div>
                        <div className="col-4"><span className="fw-bold">Responsável:</span> {dadosRelatorio.transportador.responsavel}</div>
                        <div className="col-4"><span className="fw-bold">E-mail:</span> {dadosRelatorio.transportador.email}</div>
                        <div className="col-4"><span className="fw-bold">Telefone:</span> {dadosRelatorio.transportador.fone}</div>
                        <div className="col-4"><span className="fw-bold">CEP:</span> {dadosRelatorio.transportador.cep}</div>
                        <div className="col-4"><span className="fw-bold">Cidade:</span> {dadosRelatorio.transportador.cidade}</div>
                        <div className="col-4"><span className="fw-bold">UF:</span> {dadosRelatorio.transportador.uf}</div>
                        <div className="col-4"><span className="fw-bold">Bairro:</span> {dadosRelatorio.transportador.bairro}</div>
                        <div className="col-4"><span className="fw-bold">Rua:</span> {dadosRelatorio.transportador.logradouro}</div>
                        <div className="col-4"><span className="fw-bold">Numero:</span> {dadosRelatorio.transportador.numero}</div>
                    </Row>
                    <h5 className='rounded-3 bg-secondary text-light p-2'>RESUMO DE OPERAÇÕES</h5>
                    <Row className='content-rel'>
                        <div className="col-12"><span className="fw-bold">AGRUPAMENTO:</span> {dadosRelatorio.agrupamento}</div>
                        <div className="col-12"><span className="fw-bold">QUANTIDADE DE COLETAS EFETUADAS:</span> {dadosRelatorio.quantidadeDeColetasEfetuadas}</div>
                        <div className="col-8"><span className="fw-bold">QUANTIDADE DE COLETAS DESTINADAS:</span> {dadosRelatorio.quantidadeDeColetasDestinadas}</div>
                        <div className="col-4"><span className="fw-bold">PESO TOTAL DESTINADO:</span> {parseFloat(dadosRelatorio.pesoTotalDestinado).toFixed(2).toString().replace('.', ',')} KG</div>
                    </Row>
                </div>
            </div>
        </MainCard>
    )
}